export interface StoryBlokColor {
  color: string;
}

export function isColorSet(color: StoryBlokColor) {
  return color && color.color && color.color !== '#f40000';
}
